<template>
  <div class="icon-container">
    <div class="icon-contents">
      <Icon :class="[`${type}-color`]" :name="icon_name" />
      <div class="icon-text">
        {{ text }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue'

import Icon from '@/client/components/_atoms/Icon.vue'

type TKeywordType = 'positive' | 'warning'

export default defineComponent({
  components: { Icon },
  props: {
    type: {
      type: String as PropType<TKeywordType>,
      required: true
    },
    text: {
      type: String,
      required: true
    }
  },
  computed: {
    icon_name(): string {
      return this.type === 'positive' ? 'heart' : 'alert'
    }
  }
})
</script>

<style lang="scss" scoped>
@use '@/client/assets/scss/variables.scss' as *;

.icon-container {
  box-sizing: border-box;
  display: inline-block;
  padding: $spacing-unit;
  background: $text-color-white;
  border: 1px solid $border-color;
  border-radius: $round;
}

.icon-contents {
  display: flex;
  line-height: 18px;
}

.icon-text {
  margin-left: $spacing-unit;
  overflow-wrap: break-word;
}

.positive-color {
  color: $primary-color;
}

.warning-color {
  color: $warning-color;
}
</style>
